import { call, put } from 'redux-saga/effects';
import { pushSnackbarMessage } from 'Modules/Shared/actions/app';
import { history } from 'Utils/history';

export default function* redirectToPathWithSnackbarMessage({ path, message }) {
  yield put(pushSnackbarMessage({ message }));
  yield call(history.push, `/${path}`);
}
